<template>
  <div v-if="items && items.length" class="trends-col">
    <div class="trends-col__list">
      <div v-for="(item, i) in items" :key="i" class="trends-col__item">
        <SlideComponent :trend="true" :data="item" />
      </div>
    </div>
  </div>
</template>

<script>
import SlideComponent from "components/SlideComponent.vue";

export default {
  name: "TrendsColComponent",
  components: { SlideComponent },
  props: {
    title: String,
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/ratio.styl"
.trends-col {
  &__list {
    display flex
    flex-direction column
    gap 20px
    +below(1200px) {
      display grid
      grid-template-columns 1fr 1fr
      gap 30px
    }
    +below(580px) {
      gap 20px
    }
  }

  &__item {
    border-radius var(--main_radius)
    overflow hidden

    .main-slide {
      +below(580px) {
        ratio(167, 204)
      }
    }
  }
}
</style>
